import { AUTH_ERROR, RESET_AUTH_ERROR } from "../action/AuthErrorAction";
import { STORE_RESET } from "../action/SidbarIndexAction";

const initialState = {
  error: null,
};

const authReducer = (state = initialState, action) => {
  switch (action.type) {
    case AUTH_ERROR:
      return {
        ...state,
        error: action.payload,
      };
    case RESET_AUTH_ERROR:
      return {
        ...state,
        error: null,
      };
    case STORE_RESET:
      return initialState;
    default:
      return state;
  }
};

export default authReducer;
